// THIS IS A GENERATED FILE
import * as Types from '@gatsbyjs/graphql/types';

import gql from 'graphql-tag';
import * as ApolloReactCommon from '@apollo/react-common';
import * as ApolloReactHooks from '@apollo/react-hooks';
import { useApolloFragment } from 'apollo-fragment-react';


export type MerlinSourceEventFragment = (
  { __typename?: 'MerlinSourceEvent' }
  & Pick<Types.MerlinSourceEvent, 'id' | 'status' | 'createdAt' | 'endedAt' | 'resourceId' | 'resourceType' | 'cmsVendor' | 'isFullSource' | 'tagName'>
);

export type MerlinSourceEventsBySiteQueryVariables = Types.Exact<{
  siteId: Types.Scalars['UUID'];
  pagination?: Types.Maybe<Types.CursorPagination>;
}>;


export type MerlinSourceEventsBySiteQuery = (
  { __typename?: 'Query' }
  & { paginatedMerlinSourceEventsByResourceId?: Types.Maybe<(
    { __typename?: 'MerlinSourceEventResults' }
    & { pageInfo?: Types.Maybe<(
      { __typename?: 'CursorPageInfo' }
      & Pick<Types.CursorPageInfo, 'endCursor' | 'hasNextPage'>
    )>, merlinSourceEvents?: Types.Maybe<Array<Types.Maybe<(
      { __typename?: 'MerlinSourceEvent' }
      & MerlinSourceEventFragment
    )>>> }
  )> }
);

export type PaginatedMerlinSourceEventsByResourceIdQueryVariables = Types.Exact<{
  siteId: Types.Scalars['UUID'];
  resourceType: Types.MerlinSourceEventResourceType;
  pagination?: Types.Maybe<Types.CursorPagination>;
}>;


export type PaginatedMerlinSourceEventsByResourceIdQuery = (
  { __typename?: 'Query' }
  & { paginatedMerlinSourceEventsByResourceId?: Types.Maybe<(
    { __typename?: 'MerlinSourceEventResults' }
    & { pageInfo?: Types.Maybe<(
      { __typename?: 'CursorPageInfo' }
      & Pick<Types.CursorPageInfo, 'endCursor' | 'hasNextPage'>
    )>, merlinSourceEvents?: Types.Maybe<Array<Types.Maybe<(
      { __typename?: 'MerlinSourceEvent' }
      & MerlinSourceEventFragment
    )>>> }
  )> }
);

export type PaginatedMerlinSourceEventsByResourceIdForPoolingQueryVariables = Types.Exact<{
  siteId: Types.Scalars['UUID'];
  pagination?: Types.Maybe<Types.CursorPagination>;
}>;


export type PaginatedMerlinSourceEventsByResourceIdForPoolingQuery = (
  { __typename?: 'Query' }
  & { paginatedMerlinSourceEventsByResourceIdForPooling?: Types.Maybe<(
    { __typename?: 'MerlinSourceEventResults' }
    & { merlinSourceEvents?: Types.Maybe<Array<Types.Maybe<(
      { __typename?: 'MerlinSourceEvent' }
      & MerlinSourceEventFragment
    )>>> }
  )> }
);

export type MerlinSourcingBySiteQueryVariables = Types.Exact<{
  siteId: Types.Scalars['UUID'];
}>;


export type MerlinSourcingBySiteQuery = (
  { __typename?: 'Query' }
  & { siteDetails?: Types.Maybe<(
    { __typename?: 'Site' }
    & Pick<Types.Site, 'id' | 'merlinProductionSourcingEnabled' | 'merlinGraphQLApiEnabled' | 'publicName' | 'name'>
  )> }
);

export type MerlinStatusForResourceQueryVariables = Types.Exact<{
  id: Types.Scalars['UUID'];
  resourceType?: Types.Maybe<Types.MerlinSourceEventResourceType>;
}>;


export type MerlinStatusForResourceQuery = (
  { __typename?: 'Query' }
  & { merlinStatusForResource?: Types.Maybe<(
    { __typename?: 'FullMerlinStatus' }
    & Pick<Types.FullMerlinStatus, 'status' | 'updatedAt'>
  )> }
);

export type MerlinSourceEventCreatedSubscriptionVariables = Types.Exact<{
  siteId: Types.Scalars['UUID'];
}>;


export type MerlinSourceEventCreatedSubscription = (
  { __typename?: 'Subscription' }
  & { merlinSourceEventCreated?: Types.Maybe<(
    { __typename?: 'MerlinSourceEvent' }
    & MerlinSourceEventFragment
  )> }
);

export type MerlinSourceEventChangedSubscriptionVariables = Types.Exact<{
  sourceEventId: Types.Scalars['ID'];
}>;


export type MerlinSourceEventChangedSubscription = (
  { __typename?: 'Subscription' }
  & { merlinSourceEventChanged?: Types.Maybe<(
    { __typename?: 'MerlinSourceEvent' }
    & MerlinSourceEventFragment
  )> }
);

export type MerlinStatusChangedSubscriptionVariables = Types.Exact<{
  resourceId: Types.Scalars['UUID'];
  resourceType: Types.MerlinSourceEventResourceType;
}>;


export type MerlinStatusChangedSubscription = (
  { __typename?: 'Subscription' }
  & { merlinStatusChanged?: Types.Maybe<(
    { __typename?: 'FullMerlinStatus' }
    & Pick<Types.FullMerlinStatus, 'status' | 'updatedAt'>
  )> }
);

export type MerlinSourcingDetailsQueryVariables = Types.Exact<{
  siteId: Types.Scalars['UUID'];
  organizationId: Types.Scalars['UUID'];
}>;


export type MerlinSourcingDetailsQuery = (
  { __typename?: 'Query' }
  & { siteDetails?: Types.Maybe<(
    { __typename?: 'Site' }
    & Pick<Types.Site, 'id' | 'merlinProductionSourcingEnabled' | 'merlinGraphQLApiEnabled' | 'publicName' | 'name' | 'sitePrefix'>
  )>, organizationDetails?: Types.Maybe<(
    { __typename?: 'Organization' }
    & Pick<Types.Organization, 'id'>
    & { billing?: Types.Maybe<(
      { __typename?: 'BillingInformation' }
      & Pick<Types.BillingInformation, 'id'>
      & { plan?: Types.Maybe<(
        { __typename?: 'SubscriptionPlan' }
        & Pick<Types.SubscriptionPlan, 'id'>
        & { baseFeatures?: Types.Maybe<(
          { __typename?: 'BaseFeatures' }
          & Pick<Types.BaseFeatures, 'tier'>
        )> }
      )> }
    )> }
  )> }
);

export const MerlinSourceEventFragmentDoc = gql`
    fragment MerlinSourceEvent on MerlinSourceEvent {
  id
  status
  createdAt
  endedAt
  resourceId
  resourceType
  cmsVendor
  isFullSource
  tagName
}
    `;
export const MerlinSourceEventsBySiteDocument = gql`
    query MerlinSourceEventsBySite($siteId: UUID!, $pagination: CursorPagination) {
  paginatedMerlinSourceEventsByResourceId(
    resourceId: $siteId
    resourceType: SITE
    pagination: $pagination
  ) {
    pageInfo {
      endCursor
      hasNextPage
    }
    merlinSourceEvents {
      ...MerlinSourceEvent
    }
  }
}
    ${MerlinSourceEventFragmentDoc}`;

/**
 * __useMerlinSourceEventsBySiteQuery__
 *
 * To run a query within a React component, call `useMerlinSourceEventsBySiteQuery` and pass it any options that fit your needs.
 * When your component renders, `useMerlinSourceEventsBySiteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMerlinSourceEventsBySiteQuery({
 *   variables: {
 *      siteId: // value for 'siteId'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useMerlinSourceEventsBySiteQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<MerlinSourceEventsBySiteQuery, MerlinSourceEventsBySiteQueryVariables>) {
        return ApolloReactHooks.useQuery<MerlinSourceEventsBySiteQuery, MerlinSourceEventsBySiteQueryVariables>(MerlinSourceEventsBySiteDocument, baseOptions);
      }
export function useMerlinSourceEventsBySiteLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<MerlinSourceEventsBySiteQuery, MerlinSourceEventsBySiteQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<MerlinSourceEventsBySiteQuery, MerlinSourceEventsBySiteQueryVariables>(MerlinSourceEventsBySiteDocument, baseOptions);
        }
export type MerlinSourceEventsBySiteQueryHookResult = ReturnType<typeof useMerlinSourceEventsBySiteQuery>;
export type MerlinSourceEventsBySiteLazyQueryHookResult = ReturnType<typeof useMerlinSourceEventsBySiteLazyQuery>;
export type MerlinSourceEventsBySiteQueryResult = ApolloReactCommon.QueryResult<MerlinSourceEventsBySiteQuery, MerlinSourceEventsBySiteQueryVariables>;
export const PaginatedMerlinSourceEventsByResourceIdDocument = gql`
    query PaginatedMerlinSourceEventsByResourceId($siteId: UUID!, $resourceType: MerlinSourceEventResourceType!, $pagination: CursorPagination) {
  paginatedMerlinSourceEventsByResourceId(
    resourceId: $siteId
    resourceType: $resourceType
    pagination: $pagination
  ) {
    pageInfo {
      endCursor
      hasNextPage
    }
    merlinSourceEvents {
      ...MerlinSourceEvent
    }
  }
}
    ${MerlinSourceEventFragmentDoc}`;

/**
 * __usePaginatedMerlinSourceEventsByResourceIdQuery__
 *
 * To run a query within a React component, call `usePaginatedMerlinSourceEventsByResourceIdQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaginatedMerlinSourceEventsByResourceIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaginatedMerlinSourceEventsByResourceIdQuery({
 *   variables: {
 *      siteId: // value for 'siteId'
 *      resourceType: // value for 'resourceType'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function usePaginatedMerlinSourceEventsByResourceIdQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<PaginatedMerlinSourceEventsByResourceIdQuery, PaginatedMerlinSourceEventsByResourceIdQueryVariables>) {
        return ApolloReactHooks.useQuery<PaginatedMerlinSourceEventsByResourceIdQuery, PaginatedMerlinSourceEventsByResourceIdQueryVariables>(PaginatedMerlinSourceEventsByResourceIdDocument, baseOptions);
      }
export function usePaginatedMerlinSourceEventsByResourceIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PaginatedMerlinSourceEventsByResourceIdQuery, PaginatedMerlinSourceEventsByResourceIdQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<PaginatedMerlinSourceEventsByResourceIdQuery, PaginatedMerlinSourceEventsByResourceIdQueryVariables>(PaginatedMerlinSourceEventsByResourceIdDocument, baseOptions);
        }
export type PaginatedMerlinSourceEventsByResourceIdQueryHookResult = ReturnType<typeof usePaginatedMerlinSourceEventsByResourceIdQuery>;
export type PaginatedMerlinSourceEventsByResourceIdLazyQueryHookResult = ReturnType<typeof usePaginatedMerlinSourceEventsByResourceIdLazyQuery>;
export type PaginatedMerlinSourceEventsByResourceIdQueryResult = ApolloReactCommon.QueryResult<PaginatedMerlinSourceEventsByResourceIdQuery, PaginatedMerlinSourceEventsByResourceIdQueryVariables>;
export const PaginatedMerlinSourceEventsByResourceIdForPoolingDocument = gql`
    query PaginatedMerlinSourceEventsByResourceIdForPooling($siteId: UUID!, $pagination: CursorPagination) {
  paginatedMerlinSourceEventsByResourceIdForPooling: paginatedMerlinSourceEventsByResourceId(
    resourceId: $siteId
    resourceType: SITE
    pagination: $pagination
  ) {
    merlinSourceEvents @connection(key: "merlinSourceEventsForPooling") {
      ...MerlinSourceEvent
    }
  }
}
    ${MerlinSourceEventFragmentDoc}`;

/**
 * __usePaginatedMerlinSourceEventsByResourceIdForPoolingQuery__
 *
 * To run a query within a React component, call `usePaginatedMerlinSourceEventsByResourceIdForPoolingQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaginatedMerlinSourceEventsByResourceIdForPoolingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaginatedMerlinSourceEventsByResourceIdForPoolingQuery({
 *   variables: {
 *      siteId: // value for 'siteId'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function usePaginatedMerlinSourceEventsByResourceIdForPoolingQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<PaginatedMerlinSourceEventsByResourceIdForPoolingQuery, PaginatedMerlinSourceEventsByResourceIdForPoolingQueryVariables>) {
        return ApolloReactHooks.useQuery<PaginatedMerlinSourceEventsByResourceIdForPoolingQuery, PaginatedMerlinSourceEventsByResourceIdForPoolingQueryVariables>(PaginatedMerlinSourceEventsByResourceIdForPoolingDocument, baseOptions);
      }
export function usePaginatedMerlinSourceEventsByResourceIdForPoolingLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PaginatedMerlinSourceEventsByResourceIdForPoolingQuery, PaginatedMerlinSourceEventsByResourceIdForPoolingQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<PaginatedMerlinSourceEventsByResourceIdForPoolingQuery, PaginatedMerlinSourceEventsByResourceIdForPoolingQueryVariables>(PaginatedMerlinSourceEventsByResourceIdForPoolingDocument, baseOptions);
        }
export type PaginatedMerlinSourceEventsByResourceIdForPoolingQueryHookResult = ReturnType<typeof usePaginatedMerlinSourceEventsByResourceIdForPoolingQuery>;
export type PaginatedMerlinSourceEventsByResourceIdForPoolingLazyQueryHookResult = ReturnType<typeof usePaginatedMerlinSourceEventsByResourceIdForPoolingLazyQuery>;
export type PaginatedMerlinSourceEventsByResourceIdForPoolingQueryResult = ApolloReactCommon.QueryResult<PaginatedMerlinSourceEventsByResourceIdForPoolingQuery, PaginatedMerlinSourceEventsByResourceIdForPoolingQueryVariables>;
export const MerlinSourcingBySiteDocument = gql`
    query MerlinSourcingBySite($siteId: UUID!) {
  siteDetails(id: $siteId) {
    id
    merlinProductionSourcingEnabled
    merlinGraphQLApiEnabled
    publicName
    name
  }
}
    `;

/**
 * __useMerlinSourcingBySiteQuery__
 *
 * To run a query within a React component, call `useMerlinSourcingBySiteQuery` and pass it any options that fit your needs.
 * When your component renders, `useMerlinSourcingBySiteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMerlinSourcingBySiteQuery({
 *   variables: {
 *      siteId: // value for 'siteId'
 *   },
 * });
 */
export function useMerlinSourcingBySiteQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<MerlinSourcingBySiteQuery, MerlinSourcingBySiteQueryVariables>) {
        return ApolloReactHooks.useQuery<MerlinSourcingBySiteQuery, MerlinSourcingBySiteQueryVariables>(MerlinSourcingBySiteDocument, baseOptions);
      }
export function useMerlinSourcingBySiteLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<MerlinSourcingBySiteQuery, MerlinSourcingBySiteQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<MerlinSourcingBySiteQuery, MerlinSourcingBySiteQueryVariables>(MerlinSourcingBySiteDocument, baseOptions);
        }
export type MerlinSourcingBySiteQueryHookResult = ReturnType<typeof useMerlinSourcingBySiteQuery>;
export type MerlinSourcingBySiteLazyQueryHookResult = ReturnType<typeof useMerlinSourcingBySiteLazyQuery>;
export type MerlinSourcingBySiteQueryResult = ApolloReactCommon.QueryResult<MerlinSourcingBySiteQuery, MerlinSourcingBySiteQueryVariables>;
export const MerlinStatusForResourceDocument = gql`
    query MerlinStatusForResource($id: UUID!, $resourceType: MerlinSourceEventResourceType) {
  merlinStatusForResource(resourceId: $id, resourceType: $resourceType) {
    status
    updatedAt
  }
}
    `;

/**
 * __useMerlinStatusForResourceQuery__
 *
 * To run a query within a React component, call `useMerlinStatusForResourceQuery` and pass it any options that fit your needs.
 * When your component renders, `useMerlinStatusForResourceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMerlinStatusForResourceQuery({
 *   variables: {
 *      id: // value for 'id'
 *      resourceType: // value for 'resourceType'
 *   },
 * });
 */
export function useMerlinStatusForResourceQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<MerlinStatusForResourceQuery, MerlinStatusForResourceQueryVariables>) {
        return ApolloReactHooks.useQuery<MerlinStatusForResourceQuery, MerlinStatusForResourceQueryVariables>(MerlinStatusForResourceDocument, baseOptions);
      }
export function useMerlinStatusForResourceLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<MerlinStatusForResourceQuery, MerlinStatusForResourceQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<MerlinStatusForResourceQuery, MerlinStatusForResourceQueryVariables>(MerlinStatusForResourceDocument, baseOptions);
        }
export type MerlinStatusForResourceQueryHookResult = ReturnType<typeof useMerlinStatusForResourceQuery>;
export type MerlinStatusForResourceLazyQueryHookResult = ReturnType<typeof useMerlinStatusForResourceLazyQuery>;
export type MerlinStatusForResourceQueryResult = ApolloReactCommon.QueryResult<MerlinStatusForResourceQuery, MerlinStatusForResourceQueryVariables>;
export const MerlinSourceEventCreatedDocument = gql`
    subscription MerlinSourceEventCreated($siteId: UUID!) {
  merlinSourceEventCreated(resourceId: $siteId, resourceType: SITE) {
    ...MerlinSourceEvent
  }
}
    ${MerlinSourceEventFragmentDoc}`;

/**
 * __useMerlinSourceEventCreatedSubscription__
 *
 * To run a query within a React component, call `useMerlinSourceEventCreatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useMerlinSourceEventCreatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMerlinSourceEventCreatedSubscription({
 *   variables: {
 *      siteId: // value for 'siteId'
 *   },
 * });
 */
export function useMerlinSourceEventCreatedSubscription(baseOptions?: ApolloReactHooks.SubscriptionHookOptions<MerlinSourceEventCreatedSubscription, MerlinSourceEventCreatedSubscriptionVariables>) {
        return ApolloReactHooks.useSubscription<MerlinSourceEventCreatedSubscription, MerlinSourceEventCreatedSubscriptionVariables>(MerlinSourceEventCreatedDocument, baseOptions);
      }
export type MerlinSourceEventCreatedSubscriptionHookResult = ReturnType<typeof useMerlinSourceEventCreatedSubscription>;
export type MerlinSourceEventCreatedSubscriptionResult = ApolloReactCommon.SubscriptionResult<MerlinSourceEventCreatedSubscription>;
export const MerlinSourceEventChangedDocument = gql`
    subscription MerlinSourceEventChanged($sourceEventId: ID!) {
  merlinSourceEventChanged(sourceEventId: $sourceEventId) {
    ...MerlinSourceEvent
  }
}
    ${MerlinSourceEventFragmentDoc}`;

/**
 * __useMerlinSourceEventChangedSubscription__
 *
 * To run a query within a React component, call `useMerlinSourceEventChangedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useMerlinSourceEventChangedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMerlinSourceEventChangedSubscription({
 *   variables: {
 *      sourceEventId: // value for 'sourceEventId'
 *   },
 * });
 */
export function useMerlinSourceEventChangedSubscription(baseOptions?: ApolloReactHooks.SubscriptionHookOptions<MerlinSourceEventChangedSubscription, MerlinSourceEventChangedSubscriptionVariables>) {
        return ApolloReactHooks.useSubscription<MerlinSourceEventChangedSubscription, MerlinSourceEventChangedSubscriptionVariables>(MerlinSourceEventChangedDocument, baseOptions);
      }
export type MerlinSourceEventChangedSubscriptionHookResult = ReturnType<typeof useMerlinSourceEventChangedSubscription>;
export type MerlinSourceEventChangedSubscriptionResult = ApolloReactCommon.SubscriptionResult<MerlinSourceEventChangedSubscription>;
export const MerlinStatusChangedDocument = gql`
    subscription MerlinStatusChanged($resourceId: UUID!, $resourceType: MerlinSourceEventResourceType!) {
  merlinStatusChanged(resourceId: $resourceId, resourceType: $resourceType) {
    status
    updatedAt
  }
}
    `;

/**
 * __useMerlinStatusChangedSubscription__
 *
 * To run a query within a React component, call `useMerlinStatusChangedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useMerlinStatusChangedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMerlinStatusChangedSubscription({
 *   variables: {
 *      resourceId: // value for 'resourceId'
 *      resourceType: // value for 'resourceType'
 *   },
 * });
 */
export function useMerlinStatusChangedSubscription(baseOptions?: ApolloReactHooks.SubscriptionHookOptions<MerlinStatusChangedSubscription, MerlinStatusChangedSubscriptionVariables>) {
        return ApolloReactHooks.useSubscription<MerlinStatusChangedSubscription, MerlinStatusChangedSubscriptionVariables>(MerlinStatusChangedDocument, baseOptions);
      }
export type MerlinStatusChangedSubscriptionHookResult = ReturnType<typeof useMerlinStatusChangedSubscription>;
export type MerlinStatusChangedSubscriptionResult = ApolloReactCommon.SubscriptionResult<MerlinStatusChangedSubscription>;
export const MerlinSourcingDetailsDocument = gql`
    query MerlinSourcingDetails($siteId: UUID!, $organizationId: UUID!) {
  siteDetails(id: $siteId) {
    id
    merlinProductionSourcingEnabled
    merlinGraphQLApiEnabled
    publicName
    name
    sitePrefix
  }
  organizationDetails(id: $organizationId) {
    id
    billing {
      id
      plan {
        id
        baseFeatures {
          tier
        }
      }
    }
  }
}
    `;

/**
 * __useMerlinSourcingDetailsQuery__
 *
 * To run a query within a React component, call `useMerlinSourcingDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMerlinSourcingDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMerlinSourcingDetailsQuery({
 *   variables: {
 *      siteId: // value for 'siteId'
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useMerlinSourcingDetailsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<MerlinSourcingDetailsQuery, MerlinSourcingDetailsQueryVariables>) {
        return ApolloReactHooks.useQuery<MerlinSourcingDetailsQuery, MerlinSourcingDetailsQueryVariables>(MerlinSourcingDetailsDocument, baseOptions);
      }
export function useMerlinSourcingDetailsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<MerlinSourcingDetailsQuery, MerlinSourcingDetailsQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<MerlinSourcingDetailsQuery, MerlinSourcingDetailsQueryVariables>(MerlinSourcingDetailsDocument, baseOptions);
        }
export type MerlinSourcingDetailsQueryHookResult = ReturnType<typeof useMerlinSourcingDetailsQuery>;
export type MerlinSourcingDetailsLazyQueryHookResult = ReturnType<typeof useMerlinSourcingDetailsLazyQuery>;
export type MerlinSourcingDetailsQueryResult = ApolloReactCommon.QueryResult<MerlinSourcingDetailsQuery, MerlinSourcingDetailsQueryVariables>;

  /**
   * __useMerlinSourceEventFragment__
   * To read a fragment data from Apollo Cache, call `useMerlinSourceEventFragment` and pass it the ID of the cached object.
   * When your component renders, `useMerlinSourceEventFragment` returns an object from Apollo Client cache that contains data property
   * you can use to render your UI.
   *
   * @param id a string representing the ID of the cached object that will be passed into the useApolloFragment
   *
   * @example
   * const { data } = useMerlinSourceEventFragment('fragment-id');
   */
export function useMerlinSourceEventFragment(id: string) {
          return useApolloFragment<MerlinSourceEventFragment>(MerlinSourceEventFragmentDoc, id);
        }
export type MerlinSourceEventFragmentHookResult = ReturnType<typeof useMerlinSourceEventFragment>;